import { render } from "./MailSignupSuccess.vue?vue&type=template&id=08e8958e&scoped=true"
import script from "./MailSignupSuccess.vue?vue&type=script&lang=js"
export * from "./MailSignupSuccess.vue?vue&type=script&lang=js"

import "./MailSignupSuccess.vue?vue&type=style&index=0&id=08e8958e&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/ecu-tablet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e8958e"]])

export default __exports__